import { Injectable } from '@angular/core';
import { Config } from '../config/config';
import { HttpLayerService } from './http-layer.service';
import { SharedService } from '../shared/shared.service';
import { Observable, Subject, throwError } from 'rxjs';



/**
 * api: string species the API
 * payload: the requested data to the api
 * method: method of the API request
 * loader: to display loader
 * type: whether local json or actually api
 * hideErrorMessage: to display error message
 * disableTokenValidation: to disable user data inside payload that is fetched from localstorage
 */
export class RequestPayLoadFormat {
  api: string;
  payLoad?: object;
  method: 'post' | 'get' | 'postText' | 'postFile';
  loader?: boolean;
  type: 'API' | 'JSON';
  hideErrorMessage?: boolean;
  options?: object;
  formData?: any;
  disableTokenValidation?: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class CommonServiceLayerService {

  constructor(
    private http: HttpLayerService,
    private sharedService: SharedService
  ) { }

  public COMMON_FUNCTIONS = {
    openInNewWindow: (url, width?, height?) => {
      const currentUrl = window.location.href.split('/landing/');
      url = currentUrl[0] + url;
      window.open(url, '', 'width=' + (width || 1080) + ', height=' + (height || 720) + ', scrollbars=yes');
    },
    openInNewTab: (url) => {
      const currentUrl = window.location.href.split('/landing/');
      url = currentUrl[0] + url;
      window.open(url, '_blank');
    }
  };
  public API_REQUEST(request: RequestPayLoadFormat): Observable<any> {
    try {
      if (request.type === 'JSON') {
        request.method = 'get';
      }
      return this.http[request.method](Config[request.type][request.api], request).map(
        (res: any) => {
          return res;
        });
    } catch (error) {
      console.log(error);
      this.sharedService.internalCodeError();
    }
  }
}
